// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Multi Select Component */
/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([suppress-error-message]) .validation-message {
  display: none;
}

.icon-error-tracker {
  position: absolute;
  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));
  top: 0;
  pointer-events: none;
}
.icon-error-tracker[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
    margin-block-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
    margin-block-end: 0;
  }
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea {
    flex-wrap: wrap;
    gap: 8px;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .textarea-field-group,
  :host([label-position=inline-start]) .ids-textarea .textarea-field-group {
    order: 2;
    flex: 1 1 auto;
    min-width: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  margin-top: var(--ids-space-00);
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
  :host([label-position=inline-start]) .ids-checkbox.label-state-collapsed .validation-message {
    margin-inline-start: unset;
  }
}
@container (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea {
  gap: var(--ids-label-alignment-gap);
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
  display: inline-flex;
  align-items: var(--ids-label-align-y, center);
  justify-content: flex-end;
  text-align: end;
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
  position: relative;
}
@media (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  inset-inline-end: -5px;
  top: 7px;
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
@media (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
  text-align: end;
  padding-inline-end: 0;
}
@media (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
@container (width <= 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label.required .label-checkbox span::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  right: -5px;
  top: -5px;
}
@media (width > 767px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    text-align: end;
  }
  @container (width < 320px) {
    :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
      justify-content: flex-start;
    }
  }
}
@media (width > 767px) and (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
    justify-content: flex-start;
  }
}

:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-input label,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-textarea label,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-textarea .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  column-gap: var(--ids-label-alignment-gap);
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host(.in-flex-item[label-position=inline-start]) .ids-input,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-label-alignment-gap);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input label,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .field-container,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.wrapped .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.sm, :host(.in-flex-item[label-position=inline-start]) .ids-input.mm, :host(.in-flex-item[label-position=inline-start]) .ids-input.md, :host(.in-flex-item[label-position=inline-start]) .ids-input.lg,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.sm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.mm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.md,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.lg {
  grid-template-columns: auto minmax(0, 1fr);
}

:host(.in-flex-item[label-position=inline-start]) .ids-input label {
  max-height: var(--ids-label-max-height-inline-start);
}
:host(.in-flex-item[label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
  inset-inline-end: 0;
  margin-inline-end: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-radio-group ids-text.group-label-text {
  margin-top: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    gap: 0;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    flex-wrap: wrap;
  }
}

@media (width <= 320px) {
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea {
    display: block;
    gap: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label {
    min-height: auto;
    margin-bottom: var(--ids-input-margin-bottom);
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text {
  overflow: visible;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text.required {
  padding-inline-end: 0;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text.required::after {
  inset-inline-end: -7px;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea.wrapped .validation-message {
  margin-inline-start: calc(var(--ids-label-width) + 11px);
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]:not([label-break=shrink-value]):not([size=full])) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]:not([label-break=shrink-value]):not([size=full])) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
:host([label-position=inline-start]) .ids-radio-group.label-inline,
:host([label-position=inline-end]) .ids-radio-group.label-inline {
  display: flex;
  align-items: var(--ids-label-align-y, flex-start);
  gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start]) .ids-radio-group.label-inline ids-text.group-label-text,
:host([label-position=inline-end]) .ids-radio-group.label-inline ids-text.group-label-text {
  min-width: var(--ids-label-width);
  margin-top: calc(var(--ids-space-xs) - 2px);
}
:host([label-position=inline-start]) .ids-radio-group.label-inline slot,
:host([label-position=inline-end]) .ids-radio-group.label-inline slot {
  display: flex;
  flex-direction: column;
}

:host([label-position=inline-end]) .ids-radio-group.label-inline ids-text.group-label-text {
  justify-content: end;
  order: 2;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline slot {
  order: 1;
}

:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked {
  display: flex;
  align-items: var(--ids-label-align-y, baseline);
  gap: var(--ids-space-2, 0.5rem);
  flex-direction: column;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked ids-text.group-label-text {
  min-width: var(--ids-label-width);
  order: 2;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked slot {
  display: flex;
  flex-direction: column;
  order: 1;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][label-state=collapsed]) .ids-switch label {
    padding-inline-end: 0;
    width: 0;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: -45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-state=collapsed]) {
  --ids-label-width: 0;
  width: fit-content;
}

:host(ids-checkbox[label-state=collapsed]) {
  width: fit-content;
  display: block;
}

@container (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}

@container (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

:host([label-position=inline-start][label-state=collapsed]) .ids-radio-group ids-text.group-label-text,
:host([label-position=inline-end][label-state=collapsed]) .ids-radio-group ids-text.group-label-text {
  display: none;
}

:host([label-position=inline-start][label-state=hidden]) .ids-radio-group ids-text.group-label-text,
:host([label-position=inline-end][label-state=hidden]) .ids-radio-group ids-text.group-label-text {
  visibility: hidden;
}

:host {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
  display: block;
}
:host .ids-dropdown {
  display: inline-block;
  max-width: 100%;
  width: var(--ids-box-dropdown-width, auto);
}

:host([field-indicator]) {
  --ids-field-indicator-info-margin: 0;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

:host([hidden]) {
  display: none;
}

:host([label-position=inline-start]) ids-trigger-field::part(container) {
  justify-content: var(--ids-box-justify-content, flex-start);
}

ids-trigger-field[readonly-background]:not([disabled])::part(input) {
  cursor: var(--ids-cursor-pointer);
}

ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-color-transparent);
}

.ids-dropdown {
  display: block;
  position: relative;
}
.ids-dropdown ids-trigger-field[size=full] {
  display: block;
}
.ids-dropdown.full {
  display: block;
}
.ids-dropdown.full ids-trigger-field,
.ids-dropdown.full .ids-trigger-field {
  display: block;
}
.ids-dropdown ::slotted(ids-list-box) {
  height: var(--ids-popup-maxheight);
}

.trigger-icon {
  color: var(--ids-dropdown-color-icon);
  margin: 0 0 0 var(--ids-dropdown-space-text);
  position: relative;
  top: 0;
}

:host([mode=light]) .typeahead.is-open ids-trigger-field::part(field-container) {
  background-color: var(--ids-dropdown-typeahead-color-background);
}

:host([dir=rtl]) .trigger-icon {
  margin: 0 var(--ids-dropdown-space-text) 0 0;
}

::slotted(.sub-group) {
  border-top: 1px solid var(--ids-dropdown-separator-color-border);
  padding-top: var(--ids-dropdown-separator-padding);
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(field-container) {
  margin: 0;
  border-radius: 0;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(label),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(label) {
  display: none;
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(container) {
  margin: -1px;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container) {
  box-shadow: none !important;
}
.ids-dropdown.color-variant-borderless.is-open .ids-trigger-field-slot-trigger-end {
  margin-block-start: 2px;
}
.ids-dropdown.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 12px;
  height: 50px;
}
.ids-dropdown.color-variant-borderless.field-height-lg.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 13px;
  height: 40px;
}
.ids-dropdown.color-variant-borderless.field-height-md.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 10px;
}
.ids-dropdown.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 9px;
  height: 35px;
}
.ids-dropdown.color-variant-borderless.field-height-sm.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 5px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -2px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs ids-trigger-field::part(input) {
  padding-inline: 3px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  margin-block-start: -2px;
}

:host([combobox]) .ids-dropdown.color-variant-borderless .ids-trigger-field-slot-trigger-end {
  display: flex;
  align-items: center;
  margin-block-start: 2px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-lg .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
  height: 48px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-md .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  height: 39px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-sm .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -5px;
  height: 33px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  height: 29px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xxs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  margin-block-start: 0;
}

.ids-dropdown.color-variant-in-cell ids-trigger-field::part(container) {
  margin: 1px 0;
}

.ids-dropdown.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  display: block;
  margin-block-end: 0;
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box-option) {
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(field-container) {
  background-color: var(--ids-module-nav-input-bg-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  box-shadow: none;
  color: inherit;
  overflow: hidden;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:hover::part(field-container) {
  background-color: var(--ids-module-nav-input-hover-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:active::part(field-container) {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:focus-within::part(field-container) {
  background-color: var(--ids-module-nav-input-focus-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input) {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(trigger-button) {
  background-color: var(--ids-color-transparent);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input::placeholder) {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input:active) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ids-dropdown-list::part(dropdown-list) {
  max-width: var(--ids-module-nav-expanded-size);
  width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));
}
.ids-dropdown.color-variant-module-nav ids-list-box-option {
  min-height: var(--ids-module-nav-item-height);
}
.ids-dropdown.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-dropdown.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}

:host ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-dropdown-list {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-dropdown-list {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) ids-dropdown-list {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) ids-dropdown-list {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) ids-dropdown-list {
  max-width: var(--ids-input-width-full);
}

:host ids-dropdown-list,
:host([size=full]) {
  width: var(--ids-input-width-full);
}

:host(.in-flex-item[size=xs]) {
  min-width: var(--ids-input-width-10);
}

:host(.in-flex-item[size=sm]) {
  min-width: var(--ids-input-width-20);
}

:host(.in-flex-item[size=mm]) {
  min-width: var(--ids-input-width-30);
}

:host(.in-flex-item[size=md]) {
  min-width: var(--ids-input-width-40);
}

:host(.in-flex-item[size=lg]) {
  min-width: var(--ids-input-width-50);
}

:host(.in-flex-item[label-break=shrink-value][size]),
:host(.in-flex-item[label-position=inline-start][size]) {
  min-width: 0;
}

:host([list]:not([disabled])) {
  cursor: var(--ids-cursor-pointer);
}

:host([auto-size=true]) ids-trigger-field::part(input) {
  padding-inline-end: 0;
}

:host([text-align=end]) ids-trigger-field::part(input) {
  padding-inline-end: var(--ids-dropdown-space-text);
}

:host([text-align=end][compact]) ids-trigger-field::part(input) {
  padding-inline-end: var(--ids-dropdown-space-text-compact);
}

.ids-dropdown ids-trigger-field::part(clearable-button) {
  margin-inline-end: -6px;
}

.ids-checkbox {
  margin-bottom: 0;
}

ids-trigger-field ids-tag {
  align-self: center;
  display: flex;
  margin-top: var(--ids-space-2xs);
  margin-inline-start: var(--ids-space-2xs);
  max-width: 100%;
}
ids-trigger-field ids-tag[disabled]::part(tag) {
  cursor: var(--ids-cursor-default);
}
ids-trigger-field ids-tag ids-icon {
  padding-left: 6px;
  padding-right: 1px;
  width: 12px;
  top: 0;
}

:host([tags]),
:host(:not([typeahead]):not([tags])) {
  --ids-checkbox-padding-inline-start: 18px;
}
:host([tags]) ids-trigger-field::part(content-area),
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(content-area) {
  display: flex;
  width: calc(100% - 38px);
  flex-wrap: wrap;
}
:host([tags]) ids-trigger-field::part(input),
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input) {
  opacity: 0;
  color: transparent;
  width: 0;
  padding: 0;
  flex: 1;
}
:host([tags]) ids-trigger-field::part(input)::placeholder,
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input)::placeholder {
  visibility: hidden;
}
:host([tags]) ids-trigger-field::part(input)::selection,
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input)::selection {
  color: var(--ids-color-transparent);
  background: var(--ids-color-transparent);
}
:host([tags]) ids-trigger-field ids-text,
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text {
  max-width: 100%;
}
:host([tags]) ids-trigger-field ids-text.placeholder,
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text.placeholder {
  color: var(--ids-multiselect-section-header-color);
}
:host([tags]) ids-trigger-field ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text::part(text) {
  padding-inline-start: var(--ids-space-xs);
}
:host([tags]) ids-trigger-field[compact] ids-text::part(text), :host([tags]) ids-trigger-field[field-height=xs] ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field[compact] ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field[field-height=xs] ids-text::part(text) {
  padding-inline-start: var(--ids-space-2xs);
  font-size: var(--ids-multiselect-font-size);
}

:host(:not([tags])) ids-trigger-field ids-text.placeholder {
  color: var(--ids-multiselect-section-header-color);
}
:host(:not([tags])) ids-trigger-field ids-text.placeholder::part(text) {
  padding-inline-start: 0;
}

:host([overflow=ellipsis]:not([typeahead]):not([tags])) ids-trigger-field::part(content-area) {
  width: calc(100% - 28px);
}

:host(.datagrid-editor) ids-trigger-field ids-text {
  margin-inline-start: 5px;
}

:host(:not([disabled])) .has-value ids-trigger-field::part(field-container) {
  cursor: var(--ids-cursor-pointer);
}

:host([disabled]) ids-trigger-field::part(field-container) {
  pointer-events: none;
}

:host .trigger-icon,
:host ids-trigger-button ids-icon {
  color: var(--ids-multiselect-dropdown-icon-color);
}

.is-open ids-trigger-field::part(field-container) {
  box-shadow: var(--ids-multiselect-dropdown-box-shadow);
}
.is-open ids-trigger-field::part(field-container):not(.error) {
  background-color: var(--ids-multiselect-open-background-color);
  border: var(--ids-multiselect-border-open);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-multiselect/ids-multiselect.scss","webpack://./src/components/ids-dropdown/ids-dropdown.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/themes/mixins/ids-error-tracker-mixin.scss","webpack://./src/themes/mixins/ids-field-indicator-mixin.scss","webpack://./src/themes/mixins/ids-label-position-mixin.scss"],"names":[],"mappings":"AAAA,+BAAA;ACAA,2BAAA;ACEA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;AFCF;AECE;EACE,oCAAA;AFCJ;AEEE;EACE,2CAAA;AFAJ;AEGE;EACE,uCAAA;AFDJ;AEIE;EACE,uCAAA;AFFJ;AEII;EACE,iCAAA;AFFN;AEME;EACE,uCAAA;AFJJ;AEMI;EACE,iCAAA;AFJN;AEQE;EACE,qCAAA;AFNJ;AEQI;EACE,8BAAA;AFNN;AEUE;EACE,oCAAA;AFRJ;AEUI;EACE,+BAAA;AFRN;AEYE;EACE,uCAAA;AFVJ;AEYI;EACE,gCAAA;AFVN;AEcE;EACE,aAAA;AFZJ;;AEiBE;EACE,aAAA;AFdJ;;AItDA;EACE,kBAAA;EACA,+EAAA;EACA,MAAA;EACA,oBAAA;AJyDF;AIvDE;EACE,wBAAA;EACA,MAAA;AJyDJ;;AKjEA;EACE,kBAAA;EACA,MAAA;EACA,oBAAA;ALoEF;AKlEE;EACE,wBAAA;EACA,MAAA;ALoEJ;;AKhEA;EACE,yDAAA;EACA,mBAAA;EACA,8EAAA;EACA,eAAA;EACA,sEAAA;ALmEF;;AK/CA;EAfE,sEAAA;ALkEF;AKzDE;EACE,2CAAA;AL2DJ;;AKlDA;EAnBE,+DAAA;ALyEF;AKhEE;EACE,oCAAA;ALkEJ;;AKrDA;EAvBE,kEAAA;ALgFF;AKvEE;EACE,uCAAA;ALyEJ;;AKxDA;EA3BE,kEAAA;ALuFF;AK9EE;EACE,uCAAA;ALgFJ;;AK3DA;EA/BE,kEAAA;AL8FF;AKrFE;EACE,uCAAA;ALuFJ;;AK9DA;EAnCE,gEAAA;ALqGF;AK5FE;EACE,qCAAA;AL8FJ;;AKhEE;EACE,aAAA;ALmEJ;;AM7HE;;EAEE,aAAA;EACA,6CAAA;ANgIJ;AM7HI;;EACE,6BAAA;EACA,6CAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;ANgIN;AM5HI;;EACE,WAAA;EACA,wCAAA;AN+HN;AM7HM;EAJF;;IAKI,sBAAA;ENiIN;AACF;AM7HM;EADF;;IAEI,oBAAA;IACA,mBAAA;ENiIN;AACF;AM/HM;EANF;;IAOI,oBAAA;IACA,mBAAA;ENmIN;AACF;AMhII;EApCF;;IAqCI,eAAA;IACA,QAAA;ENoIJ;EMlII;;IACE,cAAA;IACA,oBAAA;IACA,QAAA;ENqIN;EMlII;;IACE,QAAA;ENqIN;EMlII;;IACE,QAAA;IACA,cAAA;IACA,YAAA;ENqIN;EMlII;;IACE,cAAA;IACA,eAAA;IACA,QAAA;IACA,oDAAA;IAMA,uDAAA;ENgIN;AACF;AM5HE;EACE,+BAAA;AN8HJ;AM3HE;EACE;IACE,aAAA;IACA,eAAA;IACA,6CAAA;EN6HJ;EM1HI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,6CAAA;IACA,sBAAA;IACA,wBAAA;EN4HN;EMzHI;IACE,6BAAA;IACA,cAAA;EN2HN;EMxHI;IACE,kBAAA;IACA,oBAAA;EN0HN;EMvHI;IACE,OAAA;ENyHN;EMtHI;IACE,WAAA;IACA,uEAAA;IACA,wCAAA;ENwHN;EMpHM;IACE,0BAAA;ENsHR;AACF;AMjHE;EACE;IACE,aAAA;IACA,eAAA;IACA,6CAAA;ENmHJ;EMhHI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,6CAAA;IACA,sBAAA;IACA,wBAAA;ENkHN;EM/GI;IACE,6BAAA;IACA,cAAA;ENiHN;EM9GI;IACE,kBAAA;IACA,oBAAA;ENgHN;EM7GI;IACE,OAAA;EN+GN;EM5GI;IACE,WAAA;IACA,uEAAA;IACA,wCAAA;EN8GN;AACF;;AMvGE;EACE,sBAAA;AN0GJ;AMxGI;EAHF;IAII,aAAA;IACA,eAAA;IACA,6CAAA;EN2GJ;EMzGI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;IACA,wBAAA;EN2GN;EMxGI;IACE,6BAAA;IACA,cAAA;EN0GN;EMvGI;IACE,kBAAA;IACA,oBAAA;ENyGN;EMtGI;IACE,OAAA;ENwGN;EMrGI;IACE,WAAA;IACA,uEAAA;IACA,wCAAA;ENuGN;AACF;;AMjGE;;EAEE,mCAAA;ANoGJ;AMlGI;;;;EAEE,oBAAA;EACA,6CAAA;EACA,yBAAA;EACA,eAAA;ANsGN;AMpGM;EAPF;;;;IAQI,2BAAA;EN0GN;AACF;AMnHI;;;;EAWE,kBAAA;AN8GN;AMvGM;EAlBF;;;;IAmBI,2BAAA;IACA,iBAAA;IACA,iBAAA;EN6GN;AACF;AM3GM;EAxBF;;;;IAyBI,2BAAA;IACA,iBAAA;IACA,iBAAA;ENiHN;AACF;AM9GQ;;;;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,QAAA;ANmHV;AMhHU;EARF;;;;IASI,iBAAA;IACA,iBAAA;IACA,yBAAA;ENsHV;AACF;AMnHU;EAfF;;;;IAgBI,iBAAA;IACA,iBAAA;IACA,yBAAA;ENyHV;AACF;AMnHE;EACE,OAAA;ANqHJ;AMjHI;EACE,eAAA;EACA,qBAAA;ANmHN;AMjHM;EAJF;IAKI,iBAAA;ENoHN;AACF;AMlHM;EARF;IASI,iBAAA;ENqHN;AACF;AMlHQ;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;ANoHV;AM7GE;EAEI;IACE,oBAAA;IACA,mBAAA;IACA,yBAAA;IACA,eAAA;EN8GN;EM5GM;IANF;MAOI,2BAAA;IN+GN;EACF;AACF;AM9GQ;EAVF;IAWI,2BAAA;ENiHR;AACF;AM1GI;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AN4GN;AMxGE;EAEI;IACE,2BAAA;ENyGN;AACF;;AM/FI;;;;EAEE,aAAA;ANoGN;;AM9FE;;EAEE,0CAAA;ANiGJ;;AM1FE;;;;EAEE,aAAA;EACA,iBAAA;AN+FJ;AM7FI;;;;EACE,cAAA;ANkGN;AM/FI;;;;EACE,YAAA;EACA,cAAA;ANoGN;AMhGI;;;;EACE,WAAA;EACA,sBAAA;ANqGN;;AM7FE;;;;EAEE,aAAA;EACA,MAAA;EACA,0CAAA;EACA,0CAAA;ANkGJ;AMhGI;;;;EACE,cAAA;EACA,WAAA;ANqGN;AMlGI;;;;EACE,cAAA;EACA,WAAA;EACA,YAAA;ANuGN;AMpGI;;;;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;ANyGN;AMtGI;;;;EACE,cAAA;EACA,sBAAA;AN2GN;AMxGI;;;;;;;;;;;;;EACE,0CAAA;ANsHN;;AMhHE;EACE,oDAAA;ANmHJ;AM/GI;EACE,mBAAA;EACA,oBAAA;ANiHN;AM3GM;EACE,aAAA;AN6GR;;AMtGE;EACE;IACE,aAAA;IACA,+CAAA;ENyGJ;EMvGI;IACE,6BAAA;IACA,cAAA;ENyGN;EMtGI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;ENwGN;AACF;AMpGE;EACE;IACE,aAAA;IACA,+CAAA;ENsGJ;EMpGI;IACE,6BAAA;IACA,cAAA;ENsGN;EMnGI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;ENqGN;AACF;AMjGE;EACE;;IAEE,cAAA;ENmGJ;EMhGE;IACE,MAAA;ENkGJ;AACF;AM/FE;EACE;;;IAGE,eAAA;ENiGJ;AACF;;AM5FE;EACE;IACE,cAAA;IACA,MAAA;EN+FJ;EM7FI;IACE,gBAAA;IACA,6CAAA;EN+FN;AACF;;AMzFE;EACE;IACE,aAAA;IACA,+CAAA;EN4FJ;EM1FI;IACE,6BAAA;IACA,cAAA;EN4FN;EMzFI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;EN2FN;AACF;AMvFG;EACC;IACE,aAAA;IACA,+CAAA;ENyFJ;EMvFI;IACE,6BAAA;IACA,cAAA;ENyFN;EMtFI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;ENwFN;AACF;;AMlFE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;ANqFJ;AMnFI;;EACE,WAAA;EACA,cAAA;ANsFN;AMnFI;;EACE,YAAA;EACA,cAAA;ANsFN;AMlFI;;EACE,WAAA;EACA,sBAAA;ANqFN;;AM7EE;;EACE,aAAA;ANiFJ;;AMzEI;;;;EACE,iBAAA;AN+EN;AM7EM;;;;EACE,qBAAA;ANkFR;AMhFQ;;;;EACE,sBAAA;ANqFV;AMhFI;;;;EACE,wDAAA;ANqFN;;AM7EE;;EAEE,aAAA;ANgFJ;AM9EI;;EACE,cAAA;EACA,QAAA;ANiFN;AM9EI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;ANiFN;AM7EE;EACE,+BAAA;AN+EJ;;AM1EE;EACE;IACE,aAAA;IACA,+CAAA;EN6EJ;EM3EI;IACE,6BAAA;IACA,oBAAA;IACA,cAAA;IACA,QAAA;EN6EN;EM1EI;IACE,aAAA;IACA,sBAAA;IACA,cAAA;IACA,QAAA;EN4EN;AACF;;AMtEE;;EAEE,aAAA;EACA,sBAAA;EACA,oBAAA;ANyEJ;AMvEI;;EACE,WAAA;EACA,cAAA;EACA,QAAA;AN0EN;AMvEI;;EACE,YAAA;EACA,cAAA;EACA,QAAA;AN0EN;AMtEI;;EACE,sBAAA;EACA,QAAA;ANyEN;AMrEE;EACE,+BAAA;ANuEJ;;AMnEA;EACE,sDAAA;ANsEF;;AM7DI;;;;EACE,4CAAA;ANmEN;AMhEI;;;;EACE,iBAAA;ANqEN;;AM/DA;EAEI;IACE,+CAAA;ENiEJ;EM/DI;IACE,2CAAA;ENiEN;AACF;AM3DA;EAEI;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EN4DJ;EM1DI;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,sBAAA;EN4DN;EMxDI;IACE,kBAAA;IACA,0CAAA;EN0DN;EMtDI;IACE,WAAA;IACA,wCAAA;ENwDN;AACF;AMjDE;EAEI;IACE,4CAAA;ENkDN;EM/CI;IACE,4BAAA;ENiDN;AACF;;AM5CA;EAEI;IACE,cAAA;EN8CJ;EM3CE;IACE,qBAAA;EN6CJ;AACF;AMnCA;;EAEE,aAAA;EACA,iDAAA;EACA,+BAAA;ANqCF;AMnCE;;EACE,iCAAA;EACA,2CAAA;ANsCJ;AMnCE;;EACE,aAAA;EACA,sBAAA;ANsCJ;;AMjCE;EACE,oBAAA;EACA,QAAA;ANoCJ;AMjCE;EACE,QAAA;ANmCJ;;AM9BA;EACE,aAAA;EACA,+CAAA;EACA,+BAAA;EACA,sBAAA;ANiCF;AM/BE;EACE,iCAAA;EACA,QAAA;ANiCJ;AM9BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ANgCJ;;AM3BA;EACE;IACE,aAAA;IACA,eAAA;IACA,+CAAA;EN8BF;EM5BE;IACE,6BAAA;IACA,6CAAA;IACA,uDAAA;IACA,uBAAA;IACA,sBAAA;EN8BJ;EM3BE;IACE,WAAA;IACA,YAAA;EN6BJ;EMzBA;IACE,qBAAA;IACA,QAAA;EN2BF;EMvBE;IACE,WAAA;IACA,cAAA;ENyBJ;AACF;AMpBA;EACE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,+CAAA;ENsBF;EMpBE;IACE,6BAAA;IACA,6CAAA;IACA,sBAAA;IACA,mBAAA;IACA,mBAAA;ENsBJ;EMnBE;;IAEE,aAAA;IACA,6CAAA;ENqBJ;AACF;AMhBA;EAEI;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;ENiBJ;EMfI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ENmBN;EMhBI;;;IACE,sBAAA;ENoBN;EMdE;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;ENgBJ;EMdI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ENkBN;EMfI;;;IACE,sBAAA;ENmBN;AACF;AMdA;EACE,oBAAA;EAEA,kBAAA;ANeF;;AMZA;EACE,kBAAA;EACA,cAAA;ANeF;;AMZA;EAEI;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;ENcJ;EMZI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ENgBN;EMbI;;;IACE,sBAAA;ENiBN;EMXE;;;IAGE,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,+BAAA;ENaJ;EMXI;;;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;ENeN;EMZI;;;IACE,sBAAA;ENgBN;AACF;AMVE;EACE;IACE,aAAA;ENYJ;AACF;;AMRA;EAEI;IACE,aAAA;ENUJ;AACF;AMGI;;;;;;;;;;;;;;EAEE,6BAAA;ANWN;;AMFE;;EACE,aAAA;ANMJ;;AMAE;;EACE,kBAAA;ANIJ;;AC9/BA;EACE,0EAAA;EACA,sEAAA;EACA,4EAAA;EACA,wEAAA;EAEA,cAAA;ADggCF;AC9/BE;EACE,qBAAA;EACA,eAAA;EACA,0CAAA;ADggCJ;;AC5/BA;EACE,oCAAA;AD+/BF;;AC5/BA;;EAEE,2CAAA;AD+/BF;;AC5/BA;EACE,aAAA;AD+/BF;;AC3/BE;EACE,2DAAA;AD8/BJ;;AC1/BA;EACE,iCAAA;AD6/BF;;ACz/BE;EACE,8CAAA;AD4/BJ;;ACv/BA;EACE,cAAA;EACA,kBAAA;AD0/BF;ACv/BI;EACE,cAAA;ADy/BN;ACr/BE;EACE,cAAA;ADu/BJ;ACr/BI;;EAEE,cAAA;ADu/BN;ACn/BE;EACE,kCAAA;ADq/BJ;;ACh/BA;EACE,qCAAA;EACA,4CAAA;EACA,kBAAA;EACA,MAAA;ADm/BF;;AC/+BE;EACE,gEAAA;ADk/BJ;;AC9+BA;EACE,4CAAA;ADi/BF;;AC9+BA;EACE,gEAAA;EACA,kDAAA;ADi/BF;;AC3+BE;;EACE,SAAA;EACA,gBAAA;AD++BJ;AC5+BE;;EACE,aAAA;AD++BJ;;ACz+BE;EACE,YAAA;AD4+BJ;ACz+BE;EACE,2BAAA;AD2+BJ;ACv+BI;EACE,uBAAA;ADy+BN;ACp+BI;EACE,oBAAA;EACA,YAAA;ADs+BN;ACl+BM;EACE,sBAAA;ADo+BR;AC99BI;EACE,oBAAA;EACA,YAAA;ADg+BN;AC59BM;EACE,uBAAA;AD89BR;ACx9BI;EACE,mBAAA;EACA,YAAA;AD09BN;ACt9BM;EACE,sBAAA;ADw9BR;ACl9BI;EACE,mBAAA;EACA,YAAA;ADo9BN;ACh9BM;EACE,uBAAA;ADk9BR;AC58BI;EACE,mBAAA;EACA,YAAA;AD88BN;AC18BM;EACE,uBAAA;EACA,wBAAA;AD48BR;;ACp8BI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ADu8BN;ACn8BM;EACE,sBAAA;EACA,YAAA;ADq8BR;ACh8BM;EACE,uBAAA;EACA,YAAA;ADk8BR;AC77BM;EACE,uBAAA;EACA,YAAA;AD+7BR;AC17BM;EACE,wBAAA;EACA,YAAA;AD47BR;ACv7BM;EACE,wBAAA;EACA,qBAAA;ADy7BR;;ACj7BE;EACE,aAAA;ADo7BJ;;AC/6BA;EACE,oDAAA;EACA,cAAA;EACA,mBAAA;ADk7BF;ACh7BE;EACE,oDAAA;ADk7BJ;AC/6BE;EACE,cAAA;ADi7BJ;AC96BE;EACE,sDAAA;EACA,yDAAA;EACA,+FAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ADg7BJ;AC76BE;EACE,4DAAA;AD+6BJ;AC56BE;EACE,8DAAA;EACA,4DAAA;EACA,qDAAA;AD86BJ;AC36BE;EACE,4DAAA;AD66BJ;AC16BE;EACE,8CAAA;EACA,cAAA;AD46BJ;ACz6BE;EACE,8CAAA;AD26BJ;ACx6BE;EACE,gEAAA;AD06BJ;ACv6BE;EACE,oDAAA;ADy6BJ;ACt6BE;EACE,8CAAA;EACA,2JAAA;ADw6BJ;ACr6BE;EACE,6CAAA;ADu6BJ;ACp6BE;EACE,iBAAA;ADs6BJ;ACn6BE;EACE,8EAAA;ADq6BJ;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,sCAAA;ADm6BF;;ACh6BA;;EAEE,kCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;EACE,oCAAA;ADm6BF;;ACh6BA;;EAEE,YAAA;ADm6BF;;AC/5BA;EACE,iCAAA;ADk6BF;;AC95BE;EACE,qBAAA;ADi6BJ;;AC55BE;EACE,kDAAA;AD+5BJ;;AC15BE;EACE,0DAAA;AD65BJ;;ACz5BA;EACE,uBAAA;AD45BF;;AA1yCA;EACE,gBAAA;AA6yCF;;AAzyCE;EACE,kBAAA;EACA,aAAA;EACA,gCAAA;EACA,yCAAA;EACA,eAAA;AA4yCJ;AA1yCI;EACE,iCAAA;AA4yCN;AAzyCI;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AA2yCN;;AAtyCA;;EAEE,yCAAA;AAyyCF;AAtyCI;;EACE,aAAA;EACA,wBAAA;EACA,eAAA;AAyyCN;AAtyCI;;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,OAAA;AAyyCN;AAvyCM;;EACE,kBAAA;AA0yCR;AAvyCM;;EACE,mCAAA;EACA,wCAAA;AA0yCR;AAtyCI;;EACE,eAAA;AAyyCN;AAvyCM;;EACE,kDAAA;AA0yCR;AAvyCM;;EACE,yCAAA;AA0yCR;AApyCM;;;EACE,0CAAA;EACA,2CAAA;AAwyCR;;AAjyCE;EACE,kDAAA;AAoyCJ;AAlyCI;EACE,uBAAA;AAoyCN;;AA7xCI;EACE,wBAAA;AAgyCN;;AA1xCE;EACE,wBAAA;AA6xCJ;;AAtxCM;EACE,iCAAA;AAyxCR;;AAjxCI;EACE,oBAAA;AAoxCN;;AA9wCE;;EAEE,iDAAA;AAixCJ;;AA5wCE;EACE,sDAAA;AA+wCJ;AA7wCI;EACE,8DAAA;EACA,0CAAA;AA+wCN","sourcesContent":["/* Ids Multi Select Component */\n@use '../ids-dropdown/ids-dropdown' as *;\n\n.ids-checkbox {\n  margin-bottom: 0;\n}\n\nids-trigger-field {\n  ids-tag {\n    align-self: center;\n    display: flex;\n    margin-top: var(--ids-space-2xs);\n    margin-inline-start: var(--ids-space-2xs);\n    max-width: 100%;\n\n    &[disabled]::part(tag) {\n      cursor: var(--ids-cursor-default);\n    }\n\n    ids-icon{\n      padding-left: 6px;\n      padding-right: 1px;\n      width: 12px;\n      top: 0;\n    }\n  }\n}\n\n:host([tags]),\n:host(:not([typeahead]):not([tags])) {\n  --ids-checkbox-padding-inline-start: 18px;\n\n  ids-trigger-field {\n    &::part(content-area) {\n      display: flex;\n      width: calc(100% - 38px);\n      flex-wrap: wrap;\n    }\n\n    &::part(input) {\n      opacity: 0;\n      color: transparent;\n      width: 0;\n      padding: 0;\n      flex: 1;\n\n      &::placeholder {\n        visibility: hidden;\n      }\n\n      &::selection {\n        color: var(--ids-color-transparent);\n        background: var(--ids-color-transparent);\n      }\n    }\n\n    ids-text {\n      max-width: 100%;\n\n      &.placeholder {\n        color: var(--ids-multiselect-section-header-color);\n      }\n\n      &::part(text) {\n        padding-inline-start: var(--ids-space-xs);\n      }\n    }\n\n    &[compact],\n    &[field-height='xs'] {\n      ids-text::part(text) {\n        padding-inline-start: var(--ids-space-2xs);\n        font-size: var(--ids-multiselect-font-size);\n      }\n    }\n  }\n}\n\n:host(:not([tags])) ids-trigger-field {\n  ids-text.placeholder {\n    color: var(--ids-multiselect-section-header-color);\n\n    &::part(text) {\n      padding-inline-start: 0;\n    }\n  }\n}\n\n:host([overflow='ellipsis']:not([typeahead]):not([tags])) {\n  ids-trigger-field {\n    &::part(content-area) {\n      width: calc(100% - 28px);\n    }\n  }\n}\n\n:host(.datagrid-editor) ids-trigger-field {\n  ids-text {\n    margin-inline-start: 5px;\n  }\n}\n\n:host(:not([disabled])) {\n  .has-value {\n    ids-trigger-field {\n      &::part(field-container) {\n        cursor: var(--ids-cursor-pointer);\n      }\n    }\n  }\n}\n\n:host([disabled]) {\n  ids-trigger-field {\n    &::part(field-container) {\n      pointer-events: none;\n    }\n  }\n}\n\n:host {\n  .trigger-icon,\n  ids-trigger-button ids-icon {\n    color: var(--ids-multiselect-dropdown-icon-color);\n  }\n}\n\n.is-open {\n  ids-trigger-field::part(field-container) {\n    box-shadow: var(--ids-multiselect-dropdown-box-shadow);\n\n    &:not(.error) {\n      background-color: var(--ids-multiselect-open-background-color);\n      border: var(--ids-multiselect-border-open);\n    }\n  }\n}\n","/* Ids Dropdown Component */\n@use '../../themes/mixins/ids-validation-mixin';\n@use '../../themes/mixins/ids-error-tracker-mixin' as *;\n@use '../../themes/mixins/ids-field-indicator-mixin' as *;\n@use '../../themes/mixins/ids-label-position-mixin.scss' as label-position;\n\n:host {\n  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);\n  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);\n  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);\n\n  display: block;\n\n  .ids-dropdown {\n    display: inline-block;\n    max-width: 100%;\n    width: var(--ids-box-dropdown-width, auto);\n  }\n}\n\n:host([field-indicator]) {\n  --ids-field-indicator-info-margin: 0;\n}\n\n:host([field-indicator][readonly]),\n:host([field-indicator][disabled]) {\n  --ids-field-indicator-info-visibility: none;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n:host([label-position=\"inline-start\"]) {\n  ids-trigger-field::part(container) {\n    justify-content: var(--ids-box-justify-content, flex-start);\n  }\n}\n\nids-trigger-field[readonly-background]:not([disabled])::part(input) {\n  cursor: var(--ids-cursor-pointer);\n}\n\nids-trigger-field:not([autoselect])::part(input) {\n  &::selection {\n    background-color: var(--ids-color-transparent);\n  }\n}\n\n// Most Styles are in list-box, popup and trigger field\n.ids-dropdown {\n  display: block;\n  position: relative;\n\n  ids-trigger-field {\n    &[size='full'] {\n      display: block;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    ids-trigger-field,\n    .ids-trigger-field {\n      display: block;\n    }\n  }\n\n  ::slotted(ids-list-box) {\n    height: var(--ids-popup-maxheight);\n  }\n}\n\n// Icon Placement\n.trigger-icon {\n  color: var(--ids-dropdown-color-icon);\n  margin: 0 0 0 var(--ids-dropdown-space-text);\n  position: relative;\n  top: 0;\n}\n\n:host([mode='light']) {\n  .typeahead.is-open ids-trigger-field::part(field-container) {\n    background-color: var(--ids-dropdown-typeahead-color-background);\n  }\n}\n\n:host([dir='rtl']) .trigger-icon {\n  margin: 0 var(--ids-dropdown-space-text) 0 0;\n}\n\n::slotted(.sub-group) {\n  border-top: 1px solid var(--ids-dropdown-separator-color-border);\n  padding-top: var(--ids-dropdown-separator-padding);\n}\n\n// Dropdown Editor\n.ids-dropdown.color-variant-borderless,\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(field-container) {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  ids-trigger-field::part(label) {\n    display: none;\n  }\n}\n\n// Dropdown Editor Borderless\n.ids-dropdown.color-variant-borderless {\n  ids-trigger-field::part(container) {\n    margin: -1px;\n  }\n\n  ids-trigger-field::part(field-container) {\n    box-shadow: none !important;\n  }\n\n  &.is-open {\n    .ids-trigger-field-slot-trigger-end {\n      margin-block-start: 2px;\n    }\n  }\n\n  &.field-height-lg {\n    ids-trigger-field::part(input) {\n      padding-inline: 12px;\n      height: 50px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n      }\n    }\n  }\n\n  &.field-height-md {\n    ids-trigger-field::part(input) {\n      padding-inline: 13px;\n      height: 40px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 10px;\n      }\n    }\n  }\n\n  &.field-height-sm {\n    ids-trigger-field::part(input) {\n      padding-inline: 9px;\n      height: 35px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n      }\n    }\n  }\n\n  &.field-height-xs {\n    ids-trigger-field::part(input) {\n      padding-inline: 5px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -2px;\n      }\n    }\n  }\n\n  &.field-height-xxs {\n    ids-trigger-field::part(input) {\n      padding-inline: 3px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        margin-block-start: -2px;\n      }\n    }\n  }\n}\n\n:host([combobox]) {\n  .ids-dropdown.color-variant-borderless {\n    .ids-trigger-field-slot-trigger-end {\n      display: flex;\n      align-items: center;\n      margin-block-start: 2px;\n    }\n\n    &.field-height-lg {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n        height: 48px;\n      }\n    }\n\n    &.field-height-md {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        height: 39px;\n      }\n    }\n\n    &.field-height-sm {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -5px;\n        height: 33px;\n      }\n    }\n\n    &.field-height-xs {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -10px;\n        height: 29px;\n      }\n    }\n\n    &.field-height-xxs {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -10px;\n        margin-block-start: 0;\n      }\n    }\n  }\n}\n\n// Dropdown Editor In Cell\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(container) {\n    margin: 1px 0;\n  }\n}\n\n// Module Nav Color Variant\n.ids-dropdown.color-variant-module-nav {\n  color: var(--ids-module-nav-search-input-text-color);\n  display: block;\n  margin-block-end: 0;\n\n  ::slotted(ids-list-box) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ::slotted(ids-list-box-option) {\n    color: inherit;\n  }\n\n  ids-trigger-field::part(field-container) {\n    background-color: var(--ids-module-nav-input-bg-color);\n    border-radius: var(--ids-module-nav-common-border-radius);\n    border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);\n    box-shadow: none;\n    color: inherit;\n    overflow: hidden;\n  }\n\n  ids-trigger-field:hover::part(field-container) {\n    background-color: var(--ids-module-nav-input-hover-bg-color);\n  }\n\n  ids-trigger-field:active::part(field-container) {\n    background-color: var(--ids-module-nav-item-selected-bg-color);\n    border-color: var(--ids-module-nav-item-selected-text-color);\n    color: var(--ids-module-nav-item-selected-text-color);\n  }\n\n  ids-trigger-field:focus-within::part(field-container) {\n    background-color: var(--ids-module-nav-input-focus-bg-color);\n  }\n\n  ids-trigger-field::part(input) {\n    background-color: var(--ids-color-transparent);\n    color: inherit;\n  }\n\n  ids-trigger-field::part(trigger-button) {\n    background-color: var(--ids-color-transparent);\n  }\n\n  ids-trigger-field::part(input::placeholder) {\n    color: var(--ids-module-nav-search-input-placeholder-text-color);\n  }\n\n  ids-trigger-field::part(input:active) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ids-dropdown-list::part(dropdown-list) {\n    max-width: var(--ids-module-nav-expanded-size);\n    width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));\n  }\n\n  ids-list-box-option {\n    min-height: var(--ids-module-nav-item-height);\n  }\n\n  .fieldset {\n    display: contents;\n  }\n\n  .ids-input-field {\n    padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);\n  }\n}\n\n// Dropdown menu width\n:host ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='xs']) ids-dropdown-list {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-20);\n}\n\n:host([size='mm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-30);\n}\n\n:host([size='md']) ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='lg']) ids-dropdown-list {\n  max-width: var(--ids-input-width-50);\n}\n\n:host([size='full']) ids-dropdown-list {\n  max-width: var(--ids-input-width-full);\n}\n\n:host ids-dropdown-list,\n:host([size='full']) {\n  width: var(--ids-input-width-full);\n}\n\n:host(.in-flex-item[size='xs']) {\n  min-width: var(--ids-input-width-10);\n}\n\n:host(.in-flex-item[size='sm']) {\n  min-width: var(--ids-input-width-20);\n}\n\n:host(.in-flex-item[size='mm']) {\n  min-width: var(--ids-input-width-30);\n}\n\n:host(.in-flex-item[size='md']) {\n  min-width: var(--ids-input-width-40);\n}\n\n:host(.in-flex-item[size='lg']) {\n  min-width: var(--ids-input-width-50);\n}\n\n:host(.in-flex-item[label-break='shrink-value'][size]),\n:host(.in-flex-item[label-position='inline-start'][size]) {\n  min-width: 0;\n}\n\n// Change state for external dropdown list\n:host([list]:not([disabled])) {\n  cursor: var(--ids-cursor-pointer);\n}\n\n:host([auto-size=\"true\"]) {\n  ids-trigger-field::part(input) {\n    padding-inline-end: 0;\n  }\n}\n\n:host([text-align=\"end\"]) {\n  ids-trigger-field::part(input) {\n    padding-inline-end: var(--ids-dropdown-space-text);\n  }\n}\n\n:host([text-align=\"end\"][compact]) {\n  ids-trigger-field::part(input) {\n    padding-inline-end: var(--ids-dropdown-space-text-compact);\n  }\n}\n\n.ids-dropdown ids-trigger-field::part(clearable-button) {\n  margin-inline-end: -6px;\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n\n:host([suppress-error-message]) {\n  .validation-message {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// General Error-Tracker icon placement\n.icon-error-tracker {\n  position: absolute;\n  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n","// Field Indicator icon placement\n.icon-field-indicator {\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n\n.icon-field-indicator-info {\n  display: var(--ids-field-indicator-info-visibility, flex);\n  align-items: center;\n  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));\n  cursor: pointer;\n  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);\n}\n\n// Mixin to apply field indicator color variables\n@mixin field-indicator-color($color, $border-color: null) {\n  --ids-field-indicator-icon-color: #{$color};\n\n  @if $border-color {\n    --ids-input-border-default-color: #{$border-color};\n    --ids-input-color-border-hover: #{$border-color};\n    --ids-input-color-border-disabled: #{$border-color};\n    --ids-input-color-border-focus: #{$border-color};\n  }\n\n  .icon-field-indicator {\n    color: #{$color};\n  }\n}\n\n// Field indicator type classes — applied to the field container.\n.field-indicator-neutral {\n  @include field-indicator-color(var(--ids-color-accent-neutral-weak));\n}\n\n.field-indicator-info {\n  @include field-indicator-color(var(--ids-color-info-default));\n}\n\n.field-indicator-success {\n  @include field-indicator-color(var(--ids-color-success-default));\n}\n\n.field-indicator-caution {\n  @include field-indicator-color(var(--ids-color-caution-default));\n}\n\n.field-indicator-warning {\n  @include field-indicator-color(var(--ids-color-warning-default));\n}\n\n.field-indicator-error {\n  @include field-indicator-color(var(--ids-color-error-default));\n}\n\n[class*=\"field-indicator-\"].has-focus {\n  .icon-field-indicator-info {\n    display: none;\n  }\n}\n","// Label position styles\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Left aligned and Right Aligned Labels\n:host([label-position='inline-start']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    align-items: var(--ids-label-align-y, center);\n\n    // Adjust the label\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: 0;\n      box-sizing: border-box;\n      flex-shrink: 0;\n    }\n\n    // Validation on the bottom\n    .validation-message {\n      width: 100%;\n      margin-block-start: var(--ids-space-2xs);\n\n      @media (max-width: $breakpoint-md) {\n        margin-inline-start: 0;\n      }\n    }\n\n    .ids-label-text {\n      @media (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n        margin-block-end: 0;\n      }\n\n      @container (width > $breakpoint-xs) {\n        margin-inline-end: 0;\n        margin-block-end: 0;\n      }\n    }\n\n    @media (min-width: $breakpoint-xs) {\n      flex-wrap: wrap;\n      gap: 8px;\n\n      label {\n        flex: 0 0 auto;\n        margin-bottom: unset;\n        order: 1;\n      }\n\n      .field-container {\n        order: 2;\n      }\n\n      .textarea-field-group {\n        order: 2;\n        flex: 1 1 auto;\n        min-width: 0;\n      }\n\n      .validation-message {\n        flex: 1 1 100%;\n        min-width: 100%;\n        order: 3;\n        margin-block-start: calc(0px - var(--ids-space-2xs));\n\n        // Label and field sit side-by-side at this breakpoint, so the wrapped\n        // message below must indent to the field start. Applied unconditionally\n        // (not only via the JS `.wrapped` class) so alignment is deterministic\n        // and not subject to ResizeObserver timing.\n        margin-inline-start: calc(var(--ids-label-width) + 6px);\n      }\n    }\n  }\n\n  .ids-checkbox {\n    margin-top: var(--ids-space-00);\n  }\n\n  @media (min-width: #{$breakpoint-xs}) {\n    .ids-checkbox {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, center);\n\n      // Adjust the label\n      label {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding-block: var(--ids-label-padding-block);\n        box-sizing: border-box;\n        gap: var(--ids-space-xs);\n      }\n\n      .label-checkbox {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      .checkbox-wrapper {\n        position: relative;\n        display: inline-flex;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));\n        margin-block-start: var(--ids-space-2xs);\n      }\n\n      &.label-state-collapsed {\n        .validation-message {\n          margin-inline-start: unset;\n        }\n      }\n    }\n  }\n\n  @container (min-width: #{$breakpoint-xs}) {\n    .ids-checkbox {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, center);\n\n      // Adjust the label\n      label {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding-block: var(--ids-label-padding-block);\n        box-sizing: border-box;\n        gap: var(--ids-space-xs);\n      }\n\n      .label-checkbox {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      .checkbox-wrapper {\n        position: relative;\n        display: inline-flex;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Horizontal aligned: use viewport media query instead of container query\n:host([label-position='inline-start'][horizontal-aligned]) {\n  .ids-checkbox {\n    container-type: normal;\n\n    @media (width <= $breakpoint-xs) {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, center);\n\n      label {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n        gap: var(--ids-space-xs);\n      }\n\n      .label-checkbox {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      .checkbox-wrapper {\n        position: relative;\n        display: inline-flex;\n      }\n\n      .field-container {\n        flex: 1;\n      }\n\n      .validation-message {\n        width: 100%;\n        margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"]) {\n  .ids-input,\n  .ids-textarea {\n    gap: var(--ids-label-alignment-gap);\n\n    label,\n    .ids-label-text {\n      display: inline-flex;\n      align-items: var(--ids-label-align-y, center);\n      justify-content: flex-end;\n      text-align: end;\n\n      @container (width <= #{$breakpoint-xs}) {\n        justify-content: flex-start;\n      }\n\n      position: relative;\n\n      // At/under the xs breakpoint the label stacks on top of the field, so the\n      // end alignment (right-aligned, full label width) must reset to start.\n      // Kept in sync with the stacking rule below (`max-width: $breakpoint-xs`)\n      // so the boundary at exactly $breakpoint-xs doesn't leave the label\n      // right-aligned and overflowing the field.\n      @media (width <= $breakpoint-xs) {\n        justify-content: flex-start;\n        text-align: start;\n        align-self: start;\n      }\n\n      @container (width <= #{$breakpoint-xs}) {\n        justify-content: flex-start;\n        text-align: start;\n        align-self: start;\n      }\n\n      &.required {\n        &::after {\n          margin-inline-end: 0;\n          position: absolute;\n          margin-top: unset;\n          inset-inline-end: -5px;\n          top: 7px;\n\n          // stylelint-disable-next-line\n          @container (width <= #{$breakpoint-xs}) {\n            position: initial;\n            margin-top: unset;\n            inset-inline-end: initial;\n          }\n\n          // stylelint-disable-next-line\n          @media (width <= $breakpoint-xs) {\n            position: initial;\n            margin-top: unset;\n            inset-inline-end: initial;\n          }\n        }\n      }\n    }\n  }\n\n  .field-container {\n    flex: 1;\n  }\n\n  .ids-checkbox {\n    label {\n      text-align: end;\n      padding-inline-end: 0;\n\n      @media (width <= $breakpoint-xs) {\n        text-align: start;\n      }\n\n      @container (width <= #{$breakpoint-xs}) {\n        text-align: start;\n      }\n\n      &.required .label-checkbox span {\n        &::after {\n          margin-inline-end: 0;\n          position: absolute;\n          margin-top: unset;\n          right: -5px;\n          top: -5px;\n        }\n      }\n    }\n  }\n\n  // Switch label-alignment end\n  @media (width > $breakpoint-sm) {\n    .ids-switch {\n      label {\n        display: inline-flex;\n        align-items: center;\n        justify-content: flex-end;\n        text-align: end;\n\n        @container (width < #{$breakpoint-xs}) {\n          justify-content: flex-start;\n        }\n\n        @media (width < $breakpoint-xs) {\n          justify-content: flex-start;\n        }\n      }\n    }\n  }\n\n  // Radio group label-alignment end\n  .ids-radio-group {\n    ids-text.group-label-text {\n      display: inline-flex;\n      align-items: center;\n      justify-content: flex-end;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-radio-group {\n      ids-text.group-label-text {\n        justify-content: flex-start;\n      }\n    }\n  }\n}\n\n// When the label is collapsed, remove it from the input/textarea layout so the\n// end-aligned label does not reserve space.\n:host([label-position='inline-start'][label-alignment][label-state='collapsed']) {\n  .ids-input,\n  .ids-textarea {\n    label,\n    .ids-label-text {\n      display: none;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    column-gap: var(--ids-label-alignment-gap);\n  }\n}\n\n// Label break behavior for inline-start position\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count][error-tracker]) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-wrap: nowrap;\n\n    label {\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n// When validation is present with shrink-value, use grid to keep field width stable\n:host(.in-flex-item[label-position='inline-start']),\n:host([label-position='inline-start'][label-break='shrink-value'][validation-message-count]:not([error-tracker])) {\n  .ids-input,\n  .ids-textarea {\n    display: grid;\n    gap: 0;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: var(--ids-label-alignment-gap);\n\n    label {\n      grid-column: 1;\n      grid-row: 1;\n    }\n\n    .field-container {\n      grid-column: 2;\n      grid-row: 1;\n      min-width: 0;\n    }\n\n    .validation-message {\n      grid-column: 1 / -1;\n      grid-row: 2;\n      width: auto;\n      margin-inline-start: 0;\n      margin-block-start: var(--ids-space-2xs);\n    }\n\n    &.wrapped .validation-message {\n      grid-column: 2;\n      margin-inline-start: 0;\n    }\n\n    &.sm, &.mm, &.md, &.lg {\n      grid-template-columns: auto minmax(0, 1fr);\n    }\n  }\n}\n\n:host(.in-flex-item[label-position='inline-start']) {\n  .ids-input label {\n    max-height: var(--ids-label-max-height-inline-start);\n  }\n\n  .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      inset-inline-end: 0;\n      margin-inline-end: 0;\n    }\n  }\n\n  .ids-radio-group {\n    ids-text {\n      &.group-label-text {\n        margin-top: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @container (width > #{$breakpoint-xs}) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex-shrink: 0;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media (width < $breakpoint-xs) {\n    .ids-input,\n    .ids-textarea {\n      display: block;\n    }\n\n    .ids-textarea {\n      gap: 0;\n    }\n  }\n\n  @container (width < #{$breakpoint-xs}) {\n    .ids-input,\n    .ids-textarea,\n    .ids-radio-group {\n      flex-wrap: wrap;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-value']:not([validation-message-count])) {\n  @media (width <= $breakpoint-xs) {\n    .ids-textarea {\n      display: block;\n      gap: 0;\n\n      label {\n        min-height: auto;\n        margin-bottom: var(--ids-input-margin-bottom);\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n   @container (width > #{$breakpoint-xs}) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        flex: 0 1 auto;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      width: auto;\n      margin-inline-start: 0;\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-width=\"0px\"]),\n:host([label-position='inline-start'][label-width=\"0\"]) {\n  // When a label is \"inline-start\" and `label-width=\"0px\"` simply don't display it\n  .ids-label-text {\n    display: none;\n  }\n}\n\n:host([label-position='inline-start'][label-alignment=\"end\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position='inline-start'][label-alignment=\"end\"][label-wrap=\"ellipsis\"]) {\n  .ids-input,\n  .ids-textarea {\n    .ids-label-text {\n      overflow: visible;\n\n      &.required {\n        padding-inline-end: 0;\n\n        &::after {\n          inset-inline-end: -7px;\n        }\n      }\n    }\n\n    &.wrapped .validation-message {\n      margin-inline-start: calc(var(--ids-label-width) + 11px);\n    }\n  }\n}\n\n\n// Label break behavior for inline-end position\n:host([label-position='inline-end'][label-break='shrink-value']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n\n    label {\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position='inline-end'][label-break='shrink-label']) {\n  @media (width > $breakpoint-xs) {\n    .ids-radio-group {\n      display: flex;\n      align-items: var(--ids-label-align-y, baseline);\n\n      ids-text.group-label-text {\n        width: var(--ids-label-width);\n        justify-content: end;\n        flex: 0 1 auto;\n        order: 2;\n      }\n\n      slot {\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        order: 1;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-end'][label-break='break']) {\n  .ids-input,\n  .ids-textarea {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    label {\n      width: auto;\n      flex-shrink: 0;\n      order: 2;\n    }\n\n    .field-container {\n      min-width: 0;\n      flex: 0 1 auto;\n      order: 1;\n    }\n\n    // Keep validation messages below the field\n    .validation-message {\n      margin-inline-start: 0;\n      order: 3;\n    }\n  }\n\n  .ids-input {\n    gap: var(--ids-space-2, 0.5rem);\n  }\n}\n\n:host([label-position=\"inline-start\"]) {\n  --ids-label-width: var(--ids-label-width-inline-start);\n}\n\n// When label-wrap constrains the label size, ensure it stays vertically centered\n// instead of stretching to fill the flex container height\n:host([label-position=\"inline-start\"][label-wrap=\"ellipsis-no-stretch\"]),\n:host([label-position=\"inline-start\"][label-wrap=\"wrap-no-stretch\"]) {\n  .ids-input,\n  .ids-textarea {\n    label {\n      align-self: var(--ids-label-align-y, center);\n    }\n\n    .ids-label-text {\n      overflow: visible;\n    }\n  }\n}\n\n// Text area\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']:not([label-break='shrink-value']):not([size='full'])) {\n    .ids-textarea {\n      max-width: calc(370px + var(--ids-label-width));\n\n      .textarea-field {\n        width: calc(370px + var(--ids-label-width));\n      }\n    }\n  }\n}\n\n// Filter field\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) {\n    .ids-filter-field {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: var(--ids-label-align-y, baseline);\n\n      label {\n        width: var(--ids-label-width);\n        padding-block: var(--ids-label-padding-block);\n        padding-inline-end: var(--ids-label-padding-inline-end);\n        box-sizing: border-box;\n      }\n\n      // Filter field specific rules\n      #operator-button {\n        position: relative;\n        inset-inline-start: var(--ids-label-width);\n      }\n\n      // Validation on the bottom\n      .validation-message {\n        width: 100%;\n        margin-block-start: var(--ids-space-2xs);\n      }\n    }\n  }\n}\n\n// Checkboxes\n:host([label-position='inline-start'][dir='rtl']) {\n  @media (width < $breakpoint-sm) {\n    .ids-checkbox {\n      label {\n        --ids-checkbox-padding-inline-start: inherit;\n      }\n\n      .validation-message {\n        margin-inline-start: initial;\n      }\n    }\n  }\n}\n\n@media (min-width: $breakpoint-sm) {\n  :host([label-position='inline-start'][dir='rtl']) .ids-checkbox {\n    input[type='checkbox'] ~ .checkmark {\n      right: initial;\n    }\n\n    .validation-message {\n      margin-block-start: 0;\n    }\n  }\n}\n\n\n// Radio buttons\n// The inline (side) label layout is toggled by `onLabelPositionChange` in\n// ids-radio-group via the `label-inline` / `label-inline-end-stacked` classes,\n// which are driven by the group's own width. This lets the layout respond to\n// its container rather than the viewport.\n:host([label-position='inline-start']) .ids-radio-group.label-inline,\n:host([label-position='inline-end']) .ids-radio-group.label-inline {\n  display: flex;\n  align-items: var(--ids-label-align-y, flex-start);\n  gap: var(--ids-space-2, 0.5rem);\n\n  ids-text.group-label-text {\n    min-width: var(--ids-label-width);\n    margin-top: calc(var(--ids-space-xs) - 2px);\n  }\n\n  slot {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n:host([label-position='inline-end']) .ids-radio-group.label-inline {\n  ids-text.group-label-text {\n    justify-content: end;\n    order: 2;\n  }\n\n  slot {\n    order: 1;\n  }\n}\n\n// Narrow `inline-end`: stack with the label beneath the options\n:host([label-position='inline-end']) .ids-radio-group.label-inline-end-stacked {\n  display: flex;\n  align-items: var(--ids-label-align-y, baseline);\n  gap: var(--ids-space-2, 0.5rem);\n  flex-direction: column;\n\n  ids-text.group-label-text {\n    min-width: var(--ids-label-width);\n    order: 2;\n  }\n\n  slot {\n    display: flex;\n    flex-direction: column;\n    order: 1;\n  }\n}\n\n// Switch\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-switch {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: var(--ids-label-align-y, baseline);\n\n    label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      padding-inline-end: var(--ids-label-padding-inline-end);\n      padding-inline-start: 0;\n      box-sizing: border-box;\n    }\n\n    input[type='checkbox'] ~ .slider {\n      left: unset;\n      right: -45px;\n    }\n  }\n\n  :host([label-position=\"inline-start\"][label-state=\"collapsed\"]) .ids-switch label {\n    padding-inline-end: 0;\n    width: 0;\n  }\n\n  :host([label-position='inline-start'][dir='rtl']) .ids-switch {\n    input[type='checkbox'] ~ .slider {\n      left: -45px;\n      right: initial;\n    }\n  }\n}\n\n// Data Label\n@media (width > $breakpoint-sm) {\n  :host([label-position='inline-start']) .ids-data-label {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: var(--ids-label-align-y, baseline);\n\n    .label {\n      width: var(--ids-label-width);\n      padding-block: var(--ids-label-padding-block);\n      box-sizing: border-box;\n      margin-block-end: 0;\n      white-space: nowrap;\n    }\n\n    .data,\n    .description {\n      display: flex;\n      padding-block: var(--ids-label-padding-block);\n    }\n  }\n}\n\n// Responsive behavior\n@media (max-width: $breakpoint-xs) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n:host([label-state=\"collapsed\"]) {\n  --ids-label-width: 0;\n\n  width: fit-content;\n}\n\n:host(ids-checkbox[label-state=\"collapsed\"]) {\n  width: fit-content;\n  display: block;\n}\n\n@container (max-width: #{$breakpoint-xs}) {\n  :host([label-position=\"inline-start\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n\n  :host([label-position=\"inline-end\"]) {\n    .ids-input,\n    .ids-textarea,\n    .ids-filter-field {\n      display: flex;\n      flex-direction: column;\n      align-items: unset;\n      gap: var(--ids-space-2, 0.5rem);\n\n      label {\n        width: auto;\n        text-align: start;\n        padding-inline: 0;\n      }\n\n      .validation-message {\n        margin-inline-start: 0;\n      }\n    }\n  }\n}\n\n:host([label-position='inline-start'][label-state=\"hidden\"]) {\n  @media (max-width: $breakpoint-xs) {\n    .ids-input .ids-label-text {\n      display: none;\n    }\n  }\n}\n\n@container (max-width: #{$breakpoint-xs}) {\n  :host([label-position='inline-start'][label-state=\"hidden\"]) {\n    .ids-input .ids-label-text {\n      display: none;\n    }\n  }\n}\n\n// Just the label width\n:host {\n  .ids-input,\n  .ids-textarea,\n  .ids-checkbox,\n  .ids-radio,\n  .ids-switch,\n  .ids-data-label,\n  .ids-filter-field {\n    label,\n    .label {\n      width: var(--ids-label-width);\n    }\n  }\n}\n\n// Declared last so label-state wins over label-alignment/label-break/label-wrap,\n// keeping the radio group label hidden regardless of the other layout attributes.\n:host([label-position='inline-start'][label-state='collapsed']),\n:host([label-position='inline-end'][label-state='collapsed']) {\n  .ids-radio-group ids-text.group-label-text {\n    display: none;\n  }\n}\n\n:host([label-position='inline-start'][label-state='hidden']),\n:host([label-position='inline-end'][label-state='hidden']) {\n  .ids-radio-group ids-text.group-label-text {\n    visibility: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
